/*
Copyright (c) 2021
*/

import actions from '../../actions';

// reducer with initial state
const initialState = {
  video: []
};

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case actions.GetVideoAction.REQUEST_GETVIDEO:
      return {
        ...state
      };
    case actions.GetVideoAction.GETVIDEO_RECEIVED:
      return {
        ...state,
        video: action.data[0].videoPath
      };

    default:
      return state;
  }
};

export default reducer;
